import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './ui/app.js';
import { DevCosmeticsGallery } from './ui/dev/DevCosmeticsGallery.js';
import { GameEngine } from './game/engine.js';
import { NetworkClient } from './network/client.js';
import { AudioManager } from './audio/manager.js';
import { AccountProvider } from './account/context.js';
import { isDevRoute } from './dev/flags.js';

const canvas = document.getElementById('game-canvas')!;
const uiOverlay = document.getElementById('ui-overlay')!;

const websocketProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
const network = new NetworkClient(`${websocketProtocol}//${window.location.host}`);
const audio = new AudioManager();
const gameEngine = new GameEngine(canvas, network, audio);

const root = createRoot(uiOverlay);
root.render(
  React.createElement(AccountProvider, null,
    isDevRoute(window.location.pathname)
      ? React.createElement(DevCosmeticsGallery)
      : React.createElement(App, {
        gameEngine,
        network,
        audio,
      }))
);

gameEngine.start();
network.connect();

window.addEventListener('resize', () => {
  gameEngine.resize();
});
